<template>
  <div class="row">
    <div v-if="Object.keys(flp_set).length == 0">
      <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
    </div>
    <div class="col-12" v-if="Object.keys(flp_set).length > 0">
      <div class="row">
        <div class="col-3 m-color" style="padding-top: 5px;text-align: right;">Messaging allowed:</div>
        <div class="col-2" style="text-align: left;padding-left:0;">
          <b-form-checkbox v-model="flp_set.flp_allowed" name switch size="lg"></b-form-checkbox>
        </div>
        <div class="col-2"></div>
        <div class="col-5">
          <div class="row" id="lfcycle">
            <div class="col-7 m-color" style="text-align: right; padding-top:5px;">LifeCycle (days):</div>
            <div class="col-3 padd-0">
              <b-form-select v-model="flp_set.lifeCycle" :options="CountTill100()" class></b-form-select>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>

      <!-- MSG SETTINGS START -->

      <b-tabs content-class="mt-3" style="margin-top: 20px;">
        <b-tab
          v-for="flpkey in touchPool"
          :title="flp_set.msg_settings[flpkey].title + ' touch'"
          @click="selectTouch = flpkey"
          :active="selectTouch == flpkey"
          :key="flpkey"
        ></b-tab>
      </b-tabs>
      <div class="row">
        <div
          class="col-6 m-color"
          style="text-align: left;padding-left:0;"
        >{{flp_set.msg_settings[selectTouch].title}} follow-up messaging allowed:</div>
        <div class="col-6" style="text-align: right;">
          <b-form-checkbox
            v-model="flp_set.msg_settings[selectTouch].allowed"
            name
            switch
            size="lg"
            :disabled="!flp_set.flp_allowed"
          ></b-form-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="col-6" v-for="msgKey in msgKeys" :key="msgKey">
          <flpMsgContainer
            :msg_body="flp_set.msg_settings[selectTouch][msgKey]"
            :assignedId="flp_set.type +'_'+ msgKey+'_' + selectTouch"
            :allowed="flp_set.msg_settings[selectTouch].allowed && flp_set.flp_allowed"
            v-model="flp_set.msg_settings[selectTouch][msgKey]"
            :key="selectTouch+'_'+msgKey"
          />
        </div>
      </div>
      <!-- MSG SETTINGS END -->

      <!-- TIME DELAY START -->

      <div class="row" style="margin-top: 20px;">
        <div class="col-12">
          <p
            style="text-align: left;"
            class="mb-5px m-color"
          >Send in ({{selectTouch == 'flp_1' ? 'from original time' : 'from first touch message sent time'}}):</p>
          <div class="row">
            <div class="col-8" style="margin:auto;">
              <div class="row">
                <div class="col-3">Days</div>
                <div class="col-1"></div>
                <div class="col-3">Hours</div>
                <div class="col-1"></div>

                <div class="col-3">Minutes</div>
              </div>
              <SetTimeBox
                :key="selectTouch"
                v-model="flp_set.msg_settings[selectTouch].delay_for"
                :allowed="flp_set.flp_allowed && flp_set.msg_settings[selectTouch].allowed"
                :delaysetting="true"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- TIME DELAY END -->

      <!-- TIME TO SEND START -->
      <div class="row" style="margin-top: 20px;">
        <div class="col-12 padd-0">
          <p style="text-align: left;" class="mb-5px m-color">Time to send:</p>
          <b-tabs content-class="mt-3" style="margin-top: 10px;">
            <b-tab
              v-for="tab in tabsPool"
              :key="tab.value"
              :title="tab.name"
              :active="selectday == tab.value"
              @click="selectday = tab.value"
            ></b-tab>
          </b-tabs>

          <div class="row" style="margin-bottom: 20px;">
            <div class="col-6 m-color" style="text-align: left;padding-left:0;">Messaging allowed:</div>
            <div class="col-6" style="text-align: right;">
              <b-form-checkbox
                v-model="flp_set.aval_time[selectday].allowed"
                name
                switch
                size="lg"
                :disabled="!flp_set.flp_allowed"
              ></b-form-checkbox>
            </div>
          </div>

          <div class="row">
            <div class="col-6 padd-0">
              <SetTimeBox
                :key="selectday"
                v-model="flp_set.aval_time[selectday].aval_from"
                title="From"
                :allowed="flp_set.flp_allowed && flp_set.aval_time[selectday].allowed"
                addclass="aval-from-style"
              />
            </div>
            <div class="col-6 padd-0">
              <SetTimeBox
                :key="selectday"
                v-model="flp_set.aval_time[selectday].aval_till"
                title="Till"
                :allowed="flp_set.flp_allowed && flp_set.aval_time[selectday].allowed"
                addclass="aval-till-style"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- TIME TO SEND END -->
    </div>
  </div>
</template>

<script>
import SetTimeBox from "../../additionalComponents/SetTimeBox.vue";
import flpMsgContainer from "./flpMsgContainer.vue";
export default {
  name: "flpSettingTab",
  components: {
    SetTimeBox,
    flpMsgContainer
  },
  props: {
    flp_set: Object
  },
  data() {
    return {
      // flp_set: {},

      selectday: "weekday",
      selectTouch: "flp_1",
      touchPool: ["flp_1", "flp_2"],
      msgKeys: ["start_msg", "rep_msg"],
      tabsPool: [
        {
          name: "Weekday/Business day",
          value: "weekday"
        },
        { name: "Saturday", value: "saturday" },
        {
          name: "Sunday/Days off",
          value: "dayOff"
        }
      ]
    };
  },

  watch: {
    flp_set: function(obj) {
      this.$emit("settingsChanged", obj);
    }
  },

  mounted() {
    // this.flp_set = Object.assign({}, this.flp_set, this.value);
  },

  methods: {
    MsgInputBoxStyling(val) {
      let bx = this.$el.querySelector(".tagify");
      if (val) {
        bx.classList.remove("tgf-disable-input");
      } else {
        bx.classList.add("tgf-disable-input");
      }
      bx.querySelector(".tagify__input").setAttribute("contenteditable", val);
    },

    msgFromInput() {
      this.$emit(
        "input",
        this.FormatMsgInput(this.$el.querySelector(`#${this.assignedId}`).value)
      );
    },

    FormatMsgInput(ss) {
      const matcherFix = new RegExp(/\[\[\{(.*?)\}\]\]/, "gm");
      const sliceFix = str => str.slice(2, -2);

      if (ss.match(matcherFix) != null) {
        let rs = ss.match(matcherFix).map(sliceFix);
        for (let i in rs) {
          ss = JSON.parse(rs[i]).value
            ? ss.replace(rs[i], `${JSON.parse(rs[i]).value}`)
            : ss;
        }
      }
      return ss;
    },
    CountTill100() {
      let r = [];
      for (let i = 1; i < 100; i++) {
        r.push(i);
      }
      return r;
    }
  }
};
</script>
<style scoped>
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}
#lfcycle select {
  line-height: 1;
  font-size: 14px;
  padding-top: 0;
  padding-bottom: 0;
  height: 28px;
}
</style>





